import React, { Component } from "react";
import Carousel from "react-material-ui-carousel";

import {
  Button,
  Typography,
  Paper,
  Grid,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
} from "@material-ui/core";
import Fade from "@material-ui/core/Fade";
import Slide from "@material-ui/core/Slide";
import PropTypes from "prop-types";
import CloseIcon from "@material-ui/icons/Close";
import LockIcon from "@material-ui/icons/Lock";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import ReactPlayer from "react-player";
import ShareStoryComponent from "../ShareStoryComponent";
import ReportElectionIncident from "../reportInsidentComponents/ReportElectionIncident";
import ReportIncident from "../reportInsidentComponents/ReportIncident";
import { themeColors } from "app/MatxLayout/MatxTheme/themeColors";

import { withStyles } from "@material-ui/core/styles";

import { englishLanguage } from "../../../languages/englishLanguage";
import { sinhalaLanguage } from "../../../languages/sinhalaLanguage";
import { tamilLanguage } from "../../../languages/tamilLanguage";

import languageService from "app/services/languageService";
import ElectionServices from "app/services/ElectionServices";

import {
  incident_report_theme_home_border,
  share_story_theme_home_border,
  election_report_theme_home_border,
} from "../../../../appVariables";
import * as appconst from "../../../../appconst";
//play and pause video
function playVideo() {
  let video = document.getElementById("background-video");

  if (video.paused) {
    video.play();
  } else {
    video.pause();
  }
}

const styles = (theme) => ({
  slideshowImageContainer: {
    [theme.breakpoints.up("md")]: {
      width: "100%",
      height: "75vh",
      //minHeight: 690,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundPosition: "center",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
    },
    [theme.breakpoints.down("md")]: {
      width: "100%",
      height: "100vh",
      minHeight: 690,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundPosition: "center",
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
    },
  },
  sliderHeaderEnglish: {
    //Changed font size and color - by shammika
    // fontFamily: "Source Sans Pro",
    fontSize: "4rem",
    color: "white",
    fontWeight: 700,
    //textAlign: 'center',
    // textShadow: "0px 0px 5px #000000"
    [theme.breakpoints.up("sm")]: {
      fontSize: "4rem",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "4rem",
    },
  },

  sliderHeaderSinhalaAndTamil: {
    //Changed font size and color - by shammika
    // fontFamily: "Source Sans Pro",
    fontSize: "2.5rem",
    lineHeight: 1.3,
    color: "white",
    fontWeight: 700,
    //textAlign: 'center',
    // textShadow: "0px 0px 5px #000000"
    [theme.breakpoints.up("sm")]: {
      fontSize: "2.5rem",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "2.5rem",
    },
  },

  //added by shammika - How to Use
  sliderHeaderTop: {
    marginTop: 30,
    //fontFamily: "Source Sans Pro",
    fontSize: "1.5rem",
    color: "#574033",
    fontWeight: 400,
    [theme.breakpoints.down("sm")]: {
      marginTop: 40,
    },
  },
  sliderSubHeader: {
    // fontFamily: "Source Sans Pro",
    fontSize: 35,
    color: "white",
    fontWeight: 500,
    //textAlign: 'center',
    textShadow: "0px 0px 5px #000000",
  },

  slideshowButtonContainer: {
    // border: "2px solid #7E7E7E",
    backgroundColor: "rgb(126, 126, 126, 0.5)",
    position: "absolute",
    //bottom: "0",
    padding: 10,
    width: "100%",
  },

  bottomItemButton: {
    cursor: "pointer",
    // border: "1px solid #0074E1
    textAlign: "center",
    height: "100%",
    backgroundColor: "white", // added by shammika
    boxShadow:
      " 0 13px 27px -5px hsla(240, 30.1%, 28%, 0.25), 0 8px 16px -8px hsla(0, 0%, 0%, 0.3), 0 -6px 16px -6px hsla(0, 0%, 0%, 0.03)",
    transition: "all ease 200ms",

    "&:hover": {
      filter: "brightness(1)",
      transform: "scale(1.05)",
      boxShadow:
        "0 13px 40px -5px hsla(240, 30.1%, 28%, 0.12), 0 8px 32px -8px hsla(0, 0%, 0%, 0.14), 0 -6px 32px -6px hsla(0, 0%, 0%, 0.02)",
    },
    [theme.breakpoints.down("sm")]: {
      margin: 30,
    },
  },

  butonSection: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  buttonIcon: {
    width: 100,
    height: 100,
    boxShadow:
      " 0 13px 27px -5px hsla(240, 30.1%, 28%, 0.25), 0 8px 16px -8px hsla(0, 0%, 0%, 0.3), 0 -6px 16px -6px hsla(0, 0%, 0%, 0.03)",

    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#fff",
    marginTop: -50,
    borderRadius: "100px 100px 100px 100px",
    // [theme.breakpoints.up("sm")]: {
    //   width: "30%",
    // },
    [theme.breakpoints.down("sm")]: {
      width: 70,
      height: 70,
      marginTop: -40,
    },
    [theme.breakpoints.between("sm", "md")]: {
      width: 60,
      height: 60,
      marginTop: -50,
    },
  },
  buttonTitle: {
    //fontFamily: "Source Sans Pro",
    textAlign: "center",
    color: "#000", // Changed by shammika",
    fontSize: 18,
    fontWeight: 700,
  },
  buttonSubTitle: {
    // fontFamily: "Source Sans Pro",
    fontStyle: "italic",
    textAlign: "center",
    color: "#000", // changed by shammika",
    fontWeight: 400,
    fontSize: 14,
  },
  root: {
    //maxWidth: 345,
    backgroundColor: "#d9eded",
  },
  media: {
    height: 120,
  },
  // > 950 px
  formCard: {
    paddingLeft: 150,
    paddingRight: 150,
  },
  mainPadding: {
    [theme.breakpoints.up("md")]: {
      paddingLeft: 70,
      paddingRight: 70,
      paddingTop: 50,
      paddingBottom: 50,
    },
    [theme.breakpoints.down("md")]: {
      padding: 20,
      paddingTop: 30,
      paddingBottom: 30,
    },
  },

  video_left: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.up("md")]: {
      paddingLeft: 100,
      paddingRight: 20,
      paddingTop: 85,
      paddingBottom: 50,
    },
    [theme.breakpoints.down("md")]: {
      padding: 20,
      paddingTop: 30,
      paddingBottom: 30,
    },
  },

  video_right: {
    [theme.breakpoints.up("md")]: {
      paddingLeft: 20,
      paddingRight: 100,
      // paddingTop: 50,
      paddingBottom: 50,
    },
    [theme.breakpoints.down("md")]: {
      padding: 20,
      paddingTop: 30,
      paddingBottom: 30,
    },
  },
  buttonContainer: {
    [theme.breakpoints.up("md")]: {
      marginTop: -33,
      display: "flex",
    },
    [theme.breakpoints.down("md")]: {
      marginTop: 20,
      display: "block",
    },
    height: "max-content",
  },
  singleButton: {
    //height: '100%'
    flex: 1,
  },
  innerSingleButton: {
    //height: '100%'
  },

  buttonIncide: {
    // height: '100%'
  },
  videoContainer: {
    marginTop: 30,
    backgroundColor: "white",
    borderRadius: 15,
    overflow: "hidden",
    padding: 7,
    paddingBottom: 5,
    boxShadow: theme.shadows[9],
  },

  row: {
    display: "flex" /* equal height of the children */,
  },

  col: {
    flex: 1 /* additionally, equal width */,

    padding: "1em",
    border: "solid",
  },

  securePlatformCard: {
    marginTop: 20,
    background:
      "linear-gradient(135deg, #0d1b2a 0%, #1b263b 60%, #415a77 100%)",
    borderRadius: 14,
    padding: "16px 20px",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    transition: "transform 200ms ease, box-shadow 200ms ease",
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)",
    border: "1.5px solid rgba(100, 255, 218, 0.25)",
    textDecoration: "none",
    "&:hover": {
      transform: "scale(1.02)",
      boxShadow: "0 12px 40px rgba(0, 0, 0, 0.45)",
      border: "1.5px solid rgba(100, 255, 218, 0.5)",
    },
  },

  securePlatformBadge: {
    backgroundColor: "rgba(100, 255, 218, 0.15)",
    borderRadius: 10,
    padding: "10px 12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 16,
    flexShrink: 0,
  },

  "@keyframes shineSwipe": {
    "0%": { left: "-80%" },
    "50%, 100%": { left: "130%" },
  },

  "@keyframes outerPulse": {
    "0%, 100%": {
      boxShadow:
        "0 0 14px 3px rgba(56,232,255,0.6), 0 0 32px 7px rgba(2,176,245,0.28), 0 6px 28px rgba(0,100,170,0.55)",
    },
    "50%": {
      boxShadow:
        "0 0 26px 8px rgba(200,250,255,0.8), 0 0 60px 16px rgba(56,232,255,0.42), 0 10px 52px rgba(0,100,170,0.78)",
    },
  },

  lightningRing: {
    position: "relative",
    display: "inline-flex",
    borderRadius: 52,
    animation: "$outerPulse 2.2s ease-in-out infinite",
  },


  newWordHighlight: {
    background:
      "linear-gradient(135deg, #005fa3 0%, #00c6ff 60%, #38ffe8 100%)",
    WebkitTextFillColor: "white",
    color: "white",
    padding: "2px 16px 6px",
    borderRadius: 8,
    display: "inline-block",
    fontStyle: "italic",
    fontWeight: 900,
    letterSpacing: 3,
    transform: "rotate(-2deg)",
    transformOrigin: "center",
    verticalAlign: "middle",
    marginRight: 10,
    marginBottom: 4,
    textShadow: "0 1px 6px rgba(0,0,0,0.35)",
    position: "relative",
    overflow: "hidden",
    "&::after": {
      content: '""',
      position: "absolute",
      top: "-10%",
      left: "-80%",
      width: "55%",
      height: "120%",
      background:
        "linear-gradient(120deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.65) 50%, rgba(255,255,255,0) 100%)",
      transform: "skewX(-20deg)",
      animation: "$shineSwipe 2.8s ease-in-out infinite",
    },
  },

  ctaButton: {
    background: "linear-gradient(135deg, #013a5c 0%, #0073c4 100%)",
    border: "2px solid rgba(2,176,245,0.5)",
    borderRadius: 50,
    padding: "16px 42px",
    minHeight: 58,
    color: "white",
    fontWeight: 800,
    fontSize: 18,
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    gap: 12,
    boxShadow: "0 6px 32px rgba(0,115,196,0.45), 0 2px 8px rgba(0,0,0,0.25)",
    letterSpacing: 0.6,
    textTransform: "uppercase",
    transition:
      "transform 220ms ease, box-shadow 220ms ease, border-color 220ms ease, background 220ms ease",
    "&:hover": {
      background: "linear-gradient(135deg, #014d7a 0%, #0090f0 100%)",
      border: "2px solid rgba(2,176,245,0.9)",
      transform: "translateY(-3px)",
      boxShadow:
        "0 14px 48px rgba(0,115,196,0.65), 0 4px 16px rgba(0,0,0,0.3), 0 0 0 4px rgba(2,176,245,0.18)",
    },
    "&:active": {
      transform: "translateY(-1px)",
      boxShadow: "0 6px 32px rgba(0,115,196,0.5), 0 2px 8px rgba(0,0,0,0.25)",
    },
  },
});

class Carousel_home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shareStoryDialog: false,
      incidentReportDialog: false,
      electionDialog: false,
      windowActive: false,
      language: englishLanguage,
      electionStatus: "deactive",
      activeSlide: 0,
      slideIn: true,
      languageName: "English",
    };
  }

  btnClick = () => {
    console.log("aaaaaaaaaaaa");
  };

  goToSlide = (index) => {
    if (index === this.state.activeSlide) return;
    this.setState({ slideIn: false });
    setTimeout(() => {
      this.setState({ activeSlide: index, slideIn: true });
    }, 380);
  };

  async loadLanguageDetails() {
    var lng = await languageService.getLanguageDetails();

    if (lng == "Sinhala") {
      this.setState({
        language: sinhalaLanguage,
        languageName: "Sinhala",
      });
    } else if (lng == "Tamil") {
      this.setState({
        language: tamilLanguage,
        languageName: "Tamil",
      });
    }
    // console.log("Home Carousal Section:", this.state);
  }

  async getElectionTimeStatus() {
    let electionstatus = await ElectionServices.getStatus();
    this.setState({
      electionStatus: electionstatus.data.election.election_mode,
    });
  }

  componentDidMount() {
    this.loadLanguageDetails();
    this.getElectionTimeStatus();

    if (window.innerWidth <= 950) {
      this.setState({
        windowActive: true,
      });
    }

    window.addEventListener("resize", () => {
      if (window.innerWidth <= 950) {
        this.setState({
          windowActive: true,
        });
      } else {
        this.setState({
          windowActive: false,
        });
      }
    });

  }

  componentWillUnmount() {
    clearInterval(this.slideInterval);
  }

  render() {
    const { classes } = this.props;

    return (
      <div
        className="w-full"
        style={{ marginTop: 0, backgroundColor: "white" }}
      >
        {/* Carousel */}
        <Carousel
          autoPlay={false}
          indicators={false}
          navButtonsAlwaysVisible={false}
          timeout={400}
          animation={"fade"}
        >
          <Grid
            className="pb-10"
            style={
              {
                // backgroundColor: themeColors.purple1.palette.theme_color.main,
              }
            }
          >
            {/* Set Carousal BackGround Color */}
            <div
              style={{
                background:
                  this.state.activeSlide === 0
                    ? "linear-gradient(to bottom, #020f1e, #013a5c, #0077a8, #ffffff)"
                    : "linear-gradient(to bottom, #02b0f5, #02b0f5, #ffffff)",
              }}
              className={classes.slideshowImageContainer}
            >
              <Grid className="w-full px-5">
                <Fade timeout={2000} in={true}>
                  <Grid container alignItems="stretch">
                    <Grid item xs={12} md={6} className={classes.video_left}>
                      {/* Sliding text panel */}
                      <div
                        style={{
                          position: "relative",
                          flex: 1,
                          minHeight: this.state.windowActive ? "auto" : 400,
                          paddingTop: 8,
                          paddingBottom: this.state.windowActive ? 40 : 8,
                        }}
                      >
                        {/* Slide content — animates in/out */}
                        <div
                          style={{
                            position: this.state.windowActive
                              ? "relative"
                              : "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: this.state.windowActive ? "auto" : 36,
                            transition:
                              "opacity 380ms ease, transform 380ms ease",
                            opacity: this.state.slideIn ? 1 : 0,
                            transform: this.state.slideIn
                              ? "translateX(0)"
                              : "translateX(-28px)",
                            overflowY: "visible",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          {/* Slide 0: Apesalli Secure Reporting Platform */}
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              height: "100%",
                            }}
                          >
                            {/* Pill badge */}
                            <div
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 7,
                                background: "rgba(2,176,245,0.18)",
                                border: "1px solid rgba(2,176,245,0.55)",
                                borderRadius: 20,
                                padding: "5px 14px",
                                width: "fit-content",
                                marginBottom:
                                  this.state.languageName === "Tamil"
                                    ? 10
                                    : 18,
                                backdropFilter: "blur(8px)",
                              }}
                            >
                              <LockIcon
                                style={{ fontSize: 13, color: "white" }}
                              />
                              <Typography
                                style={{
                                  color: "white",
                                  fontSize: 11,
                                  fontWeight: 700,
                                  letterSpacing: 2,
                                  textTransform: "uppercase",
                                  lineHeight: 1,
                                }}
                              >
                                {this.state.language.securePlatform_badge}
                              </Typography>
                            </div>

                            {/* Main heading */}
                            <Typography
                              style={{
                                color: "white",
                                fontWeight: 800,
                                fontSize:
                                  this.state.languageName === "Tamil"
                                    ? "1.5rem"
                                    : this.state.windowActive
                                      ? "2.2rem"
                                      : "3.6rem",
                                lineHeight: 1.2,
                                marginBottom:
                                  this.state.languageName === "Tamil"
                                    ? 6
                                    : 10,
                                letterSpacing: -0.5,
                              }}
                            >
                              {(() => {
                                const t =
                                  this.state.language.securePlatform_title1;
                                const idx = t.indexOf(" ");
                                if (idx === -1) return t;
                                return (
                                  <>
                                    <span
                                      className={classes.newWordHighlight}
                                    >
                                      {t.slice(0, idx)}
                                    </span>
                                    {t.slice(idx)}
                                  </>
                                );
                              })()}
                              <br />
                              <span style={{ opacity: 0.85 }}>
                                {this.state.language.securePlatform_title2}
                              </span>
                            </Typography>

                            {/* Accent bar */}
                            <div
                              style={{
                                width: 44,
                                height: 4,
                                borderRadius: 2,
                                background:
                                  "linear-gradient(90deg, #02b0f5, #38e8ff)",
                                marginBottom: 18,
                                boxShadow: "0 0 12px rgba(2,176,245,0.7)",
                              }}
                            />

                            {/* Description */}
                            <Typography
                              style={{
                                color: "rgba(255,255,255,0.85)",
                                fontSize:
                                  this.state.languageName === "Tamil"
                                    ? 12.5
                                    : this.state.windowActive
                                      ? 13
                                      : 14.5,
                                lineHeight: 1.65,
                                marginBottom:
                                  this.state.languageName === "Tamil"
                                    ? 10
                                    : this.state.windowActive
                                      ? 14
                                      : 20,
                                maxWidth: 400,
                              }}
                            >
                              {this.state.language.securePlatform_description}
                            </Typography>

                            {/* Feature chips */}
                            <div
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: 8,
                                marginBottom:
                                  this.state.languageName === "Tamil"
                                    ? 10
                                    : 26,
                              }}
                            >
                              {[
                                this.state.language.securePlatform_chip1,
                                this.state.language.securePlatform_chip2,
                                this.state.language.securePlatform_chip3,
                              ].map((label, i) => (
                                <div
                                  key={i}
                                  style={{
                                    background: "rgba(2,176,245,0.12)",
                                    border: "1px solid rgba(2,176,245,0.4)",
                                    borderRadius: 20,
                                    padding: "5px 14px",
                                  }}
                                >
                                  <Typography
                                    style={{
                                      color: "white",
                                      fontSize: 12,
                                      fontWeight: 600,
                                      lineHeight: 1,
                                    }}
                                  >
                                    {label}
                                  </Typography>
                                </div>
                              ))}
                            </div>

                            {/* CTA Button */}
                            <div>
                              <div className={classes.lightningRing}>
                                <button
                                  onClick={() =>
                                    window.location.href = "https://report.apesalli.lk"
                                  }
                                  className={classes.ctaButton}
                                >
                                  {this.state.language.securePlatform_cta}
                                  <ArrowForwardIcon style={{ fontSize: 18 }} />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </Grid>

                    <Grid item xs={12} md={6} className={classes.video_right}>
                      <Grid>
                        <ReactPlayer
                          className={classes.videoContainer}
                          width="100%"
                          height="100%"
                          url={
                            this.state.languageName === "English"
                              ? appconst.HOMEPAGE_VIDEO_LOCATION_ENGLISH
                              : this.state.languageName === "Sinhala"
                                ? appconst.HOMEPAGE_VIDEO_LOCATION_SINHALA
                                : appconst.HOMEPAGE_VIDEO_LOCATION_TAMIL
                          }
                          controls={true}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Fade>
              </Grid>
            </div>

            <Slide timeout={2000} in={true} direction="up">
              <Grid
                container
                className={classes.buttonContainer}
                spacing={2}
                //alignItems="center"
                justify="center"
                direction="row"
                style={{ margingTop: "20px" }}
              >
                {/* Bottom Item Button 01 */}
                {/* <Grid elevation={5} item xs={11} md={3} onClick={() => { this.setState({ shareStoryDialog: true }) }} > */}
                {/* <Grid item xs={11} md={3} onClick={() => { window.location.href = "/shareStory" }}  > */}
                <Grid
                  className={classes.singleButton}
                  item
                  xs={12}
                  md={3}
                  sm={12}
                  onClick={() => {
                    window.location.href = "/reportCorruptionIncident";
                  }}
                >
                  <Grid
                    elevation={5}
                    className={[classes.bottomItemButton]}
                    // style={{ borderRadius: 10,background: "linear-gradient(to right, #e52d27, #b31217)"}}
                    style={{
                      borderRadius: 10,
                      background: "white",
                      // borderBottom: "12px solid #e52d27",
                      borderBottom: `12px solid ${incident_report_theme_home_border}`,
                    }}
                  >
                    <div className={classes.butonSection}>
                      <div
                        className={classes.buttonIcon}
                        style={{
                          background: incident_report_theme_home_border, //"#e52d27",
                        }}
                      >
                        <img
                          alt="say something"
                          src="/assets/images/saySomething.png"
                          style={{ width: "100%", paddingTop: 1 }}
                        />
                      </div>
                    </div>

                    <Grid
                      container
                      className={classes.buttonIncide}
                      alignItems="center"
                      justify="center"
                      direction="column" // changed row to column by shammika
                    >
                      <Grid item xs={7}>
                        {this.state.languageName === "English" && (
                          <Typography
                            variant="h5"
                            className={["py-3", classes.buttonTitle]}
                          >
                            {/* If you see something, say something */}
                            {this.state.language.incidentReportButtonTitle_Story.toUpperCase()}
                          </Typography>
                        )}
                        {this.state.languageName === "Sinhala" && (
                          <Typography
                            variant="h5"
                            style={{
                              fontSize: 18,
                              // color: 'red',
                            }}
                            className={["py-3", classes.buttonTitle]}
                          >
                            {/* If you see something, say something */}
                            {this.state.language.incidentReportButtonTitle_Story.toUpperCase()}
                          </Typography>
                        )}
                        {this.state.languageName === "Tamil" && (
                          <Typography
                            variant="h5"
                            style={{
                              fontSize: 12,
                              // color: 'red',
                            }}
                            className={["py-3", classes.buttonTitle]}
                          >
                            {/* If you see something, say something*/}
                            {
                              this.state.language
                                .incidentReportButtonTitle_Story
                            }
                          </Typography>
                        )}
                      </Grid>
                    </Grid>
                    <Grid item xs={12}>
                      {this.state.languageName === "English" && (
                        <Typography
                          variant="h6"
                          className={["px-5", classes.buttonSubTitle]}
                        >
                          {/* Share your experience and views on bribery and corruption */}
                          {
                            this.state.language
                              .incidentReportButtonDescription_Story
                          }
                        </Typography>
                      )}
                      {this.state.languageName === "Sinhala" && (
                        <Typography
                          variant="h6"
                          style={{
                            fontSize: 12,
                            // color: 'red',
                          }}
                          className={["px-5", classes.buttonSubTitle]}
                        >
                          {/* Share your experience and views on bribery and corruption */}
                          {
                            this.state.language
                              .incidentReportButtonDescription_Story
                          }
                        </Typography>
                      )}
                      {this.state.languageName === "Tamil" && (
                        <Typography
                          variant="h6"
                          style={{
                            fontSize: 10,
                            // color: 'red',
                          }}
                          className={[classes.buttonSubTitle]}
                        >
                          {/* Share your experience and views on bribery and corruption */}
                          {
                            this.state.language
                              .incidentReportButtonDescription_Story
                          }
                        </Typography>
                      )}
                    </Grid>
                  </Grid>
                </Grid>

                {/* Bottom Item Button 02 */}
                {/* <Grid item xs={11} md={3} onClick={() => { this.setState({ incidentReportDialog: true }) }}  > */}
                {/* <Grid item xs={11} md={3} onClick={() => { window.location.href = "/reportCorruptionIncident" }}  > */}
                <Grid
                  className={classes.singleButton}
                  item
                  xs={12}
                  md={3}
                  sm={12}
                  onClick={() => {
                    window.location.href = "/shareStory";
                  }}
                >
                  <Grid
                    elevation={5}
                    className={[classes.bottomItemButton]}
                    // style={{ borderRadius: 10,background: 'linear-gradient(to right, #f15111, #eb4b0c)'}}
                    style={{
                      borderRadius: 10,
                      background: "white",
                      // borderBottom: "12px solid #f15111"
                      borderBottom: `12px solid ${share_story_theme_home_border}`,
                    }}
                  >
                    <Grid className={classes.butonSection}>
                      <Grid
                        className={classes.buttonIcon}
                        style={{
                          background: share_story_theme_home_border, //"#f15111"
                        }}
                      >
                        <img
                          alt="share Img"
                          // src="/assets/images/share.png"
                          src="/assets/images/share.png"
                          style={{ width: "100%", paddingTop: 1 }}
                        />
                      </Grid>
                    </Grid>

                    <Grid
                      container
                      className={classes.buttonIncide}
                      alignItems="center"
                      justify="center"
                      direction="column" // changed row to column by shammika
                    >
                      <Grid item xs={7}>
                        {this.state.languageName === "English" && (
                          <Typography
                            variant="h5"
                            className={["py-3", classes.buttonTitle]}
                          >
                            {/* Words move hearts, hearts move limbs */}
                            {this.state.language.incidentReportButtonTitle_Corruption.toUpperCase()}
                          </Typography>
                        )}
                        {this.state.languageName === "Sinhala" && (
                          <Typography
                            variant="h5"
                            style={{
                              fontSize: 18,
                              // color: 'red',
                            }}
                            className={["py-3", classes.buttonTitle]}
                          >
                            {/* Words move hearts, hearts move limbs */}
                            {this.state.language.incidentReportButtonTitle_Corruption.toUpperCase()}
                          </Typography>
                        )}
                        {this.state.languageName === "Tamil" && (
                          <Typography
                            variant="h5"
                            style={{
                              fontSize: 12,
                              // color: 'red',
                            }}
                            className={["py-3", classes.buttonTitle]}
                          >
                            {/* Words move hearts, hearts move limbs */}
                            {this.state.language.incidentReportButtonTitle_Corruption.toUpperCase()}
                          </Typography>
                        )}
                      </Grid>
                    </Grid>
                    <Grid item xs={12}>
                      {this.state.languageName === "English" && (
                        <Typography
                          variant="h6"
                          className={["px-5", classes.buttonSubTitle]}
                        >
                          {/* Report incidents of bribery and corruption to TISL */}
                          {
                            this.state.language
                              .incidentReportButtonDescription_Corruption
                          }
                        </Typography>
                      )}
                      {this.state.languageName === "Sinhala" && (
                        <Typography
                          variant="h6"
                          style={{
                            fontSize: 10,
                            // color: 'red',
                          }}
                          className={[classes.buttonSubTitle]}
                        >
                          {/* Report incidents of bribery and corruption to TISL */}
                          {
                            this.state.language
                              .incidentReportButtonDescription_Corruption
                          }
                        </Typography>
                      )}
                      {this.state.languageName === "Tamil" && (
                        <Typography
                          variant="h6"
                          style={{
                            fontSize: 10,
                            // color: 'red',
                          }}
                          className={[classes.buttonSubTitle]}
                        >
                          {/* Report incidents of bribery and corruption to TISL */}
                          {
                            this.state.language
                              .incidentReportButtonDescription_Corruption
                          }
                        </Typography>
                      )}
                    </Grid>
                  </Grid>
                </Grid>

                {/* Bottom Button Item 03 */}
                {/* <Grid item xs={11} md={3} onClick={() => { this.setState({ electionDialog: true }) }}  > */}

                {this.state.electionStatus == "active" ? (
                  <Grid
                    className={classes.singleButton}
                    item
                    xs={12}
                    md={3}
                    sm={12}
                    onClick={() => {
                      window.location.href = "/reportElectionIncident";
                    }}
                  >
                    <Grid
                      elevation={5}
                      className={[classes.bottomItemButton]}
                      // style={{ borderRadius: 10, background: "linear-gradient(to right, #f7cf1f, #eec302)" }}
                      style={{
                        borderRadius: 10,
                        background: "white",
                        borderBottom: `12px solid ${election_report_theme_home_border}`,
                      }}
                    >
                      <Grid className={classes.butonSection}>
                        <Grid
                          className={classes.buttonIcon}
                          style={{
                            background: election_report_theme_home_border,
                          }}
                        >
                          <img
                            alt="electionReportLogo"
                            src="/assets/images/btnElectionLogo.png"
                            style={{ width: "100%", paddingTop: 1 }}
                          />
                        </Grid>
                      </Grid>

                      <Grid
                        container
                        className={classes.buttonIncide}
                        alignItems="center"
                        justify="center"
                        direction="column" // changed row to column by shammika
                      >
                        <Grid item xs={7}>
                          {this.state.languageName === "English" && (
                            <Typography
                              variant="h5"
                              className={["py-3", classes.buttonTitle]}
                            >
                              {/* Election Violations */}
                              {this.state.language.incidentReportButtonTitle_Election.toUpperCase()}
                            </Typography>
                          )}

                          {this.state.languageName === "Sinhala" && (
                            <Typography
                              variant="h5"
                              className={["py-3", classes.buttonTitle]}
                              style={{
                                fontSize: 18,
                                // color: 'red',
                              }}
                            >
                              {/* Election Violations */}
                              {this.state.language.incidentReportButtonTitle_Election.toUpperCase()}
                            </Typography>
                          )}
                          {this.state.languageName === "Tamil" && (
                            <Typography
                              variant="h5"
                              className={["pt-3", classes.buttonTitle]}
                              style={{
                                fontSize: 12,
                                // color: 'red',
                              }}
                            >
                              {/* Election Violations */}
                              {this.state.language.incidentReportButtonTitle_Election.toUpperCase()}
                            </Typography>
                          )}

                          {this.state.language == sinhalaLanguage ? null : (
                            <div style={{ height: 21 }}></div>
                          )}
                        </Grid>
                      </Grid>
                      <Grid item xs={12}>
                        {this.state.languageName === "English" && (
                          <Typography
                            variant="h6"
                            className={["px-5", classes.buttonSubTitle]}
                          >
                            {/* If you see violations, Report election violations to TISL */}
                            {
                              this.state.language
                                .incidentReportButtonDescription_Election
                            }
                          </Typography>
                        )}
                        {this.state.languageName === "Sinhala" && (
                          <Typography
                            variant="h6"
                            style={{
                              fontSize: 12,
                              // color: 'red',
                            }}
                            className={["px-5", classes.buttonSubTitle]}
                          >
                            {/* If you see violations, Report election violations to TISL */}
                            {
                              this.state.language
                                .incidentReportButtonDescription_Election
                            }
                          </Typography>
                        )}
                        {this.state.languageName === "Tamil" && (
                          <Typography
                            variant="h6"
                            style={{
                              fontSize: 10,
                              // color: 'red',
                            }}
                            className={["px-5", classes.buttonSubTitle]}
                          >
                            {/* If you see violations, Report election violations to TISL */}
                            {
                              this.state.language
                                .incidentReportButtonDescription_Election
                            }
                          </Typography>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                ) : (
                  <Grid></Grid>
                )}
              </Grid>
            </Slide>
          </Grid>
        </Carousel>
        <div>
          {/* <Dialog
            // onClose={()=>{this.setState({shareStoryDialog:false})}}
            fullScreen
            maxWidth={"md"}
            aria-labelledby="simple-dialog-title"
            open={this.state.shareStoryDialog}
          >
            <DialogContent>
              <div style={{ float: "right" }}>
                <IconButton
                  onClick={() => {
                    this.setState({ shareStoryDialog: false });
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </div>

              {this.state.windowActive ? (
                <div>
                  <ShareStoryComponent />
                </div>
              ) : (
                <div className={classes.formCard}>
                  <ShareStoryComponent />
                </div>
              )}
            </DialogContent>
          </Dialog> */}

          {/* <Dialog
            // onClose={()=>{this.setState({incidentReportDialog:false})}}
            fullScreen
            maxWidth={"md"}
            aria-labelledby="simple-dialog-title"
            open={this.state.incidentReportDialog}
          >
            <DialogContent>
              <div style={{ float: "right" }}>
                <IconButton
                  onClick={() => {
                    this.setState({ incidentReportDialog: false });
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </div>

              {this.state.windowActive ? (
                <div>
                  <ReportIncident />
                </div>
              ) : (
                <div className={classes.formCard}>
                  <ReportIncident />
                </div>
              )}
            </DialogContent>
          </Dialog> */}

          {/* <Dialog
            // onClose={()=>{this.setState({electionDialog:false})}}
            fullScreen
            maxWidth={"md"}
            aria-labelledby="simple-dialog-title"
            open={this.state.electionDialog}
          >
            <DialogContent>
              <div style={{ float: "right" }}>
                <IconButton
                  onClick={() => {
                    this.setState({ electionDialog: false });
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </div>

              {this.state.windowActive ? (
                <div>
                  <ReportElectionIncident />
                </div>
              ) : (
                <div className={classes.formCard}>
                  <ReportElectionIncident />
                </div>
              )}
            </DialogContent>
          </Dialog> */}
        </div>
      </div>
    );
  }
}

Carousel_home.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Carousel_home);
